import type { TMap } from '@shared/types';

import type { TDocument, TRefData } from '../types';

export const newRefIds = (doc: TDocument, refsData: TMap<string, TRefData> | undefined): string[] =>
  Object.keys(refsData ?? {}).filter((id) => !(id in doc.refsData));

export const withRefsData = (doc: TDocument, refsData: TMap<string, TRefData> | undefined): TDocument => {
  const newIds = newRefIds(doc, refsData);
  if (newIds.length === 0) return doc;
  return {
    ...doc,
    refsData: { ...doc.refsData, ...refsData },
    draft: doc.draft && { ...doc.draft, outRefs: [...doc.draft.outRefs, ...newIds] },
  };
};

export const withoutRefsData = (doc: TDocument, ids: string[]): TDocument => {
  const gone = new Set(ids.filter((id) => id in doc.refsData));
  if (gone.size === 0) return doc;
  const refsData = { ...doc.refsData };
  for (const id of gone) delete refsData[id];
  return {
    ...doc,
    refsData,
    draft: doc.draft && { ...doc.draft, outRefs: doc.draft.outRefs.filter((id) => !gone.has(id)) },
  };
};
